export const GET_PAD_LIST = 'GET_PAD_LIST';
export const SET_PAD_LIST = 'SET_PAD_LIST';
export const SET_SELECTED_PAD = 'SET_SELECTED_PAD';
export const GET_PAD_DETAIL = 'GET_PAD_DETAIL';
export const SET_PAD_DETAIL = 'SET_PAD_DETAIL';
export const INSERT_PAD = 'INSERT_PAD';
export const UPDATE_PAD = 'UPDATE_PAD';
export const DELETE_PAD = 'DELETE_PAD';
